import type { FileTypeEnum } from '@/shared/api/intranet'
import { uploadImage } from '@/shared/lib/media'

export const useAttachments = () => {
  const attachmentsToUpload = ref<File[]>([])

  const uploadAttachments = async (file_type: FileTypeEnum) => {
    const promises = []
    for (const file of attachmentsToUpload.value) {
      promises.push(uploadImage(file, file_type))
    }
    const results = await Promise.all(promises)
    return results.map((result) => result.media_id)
  }
  return {
    attachmentsToUpload,
    uploadAttachments,
  }
}
